import React, { useState, useEffect } from 'react';
import Footer from '../Footer';

const Electronic = () => {
  const [message, setMessage] = useState("Upcoming Electronic");

  useEffect(() => {
    const interval = setInterval(() => {
      setMessage((prevMessage) =>
        prevMessage === "Upcoming Electronic" ? "Stay Tuned, Coming Soon!" : "Upcoming Electronic"
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Ensures the height covers the full viewport
      }}
    >
      {/* Main Content */}
      <div style={{ flex: 1, textAlign: 'center', marginTop: '20px' }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '20px' }}>{message}</h2>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Electronic;
